import { ProgramType } from "../models/Program";
import { ProgramRequestStatus } from "../models/ProgramRequest/ProgramRequestStatus";

export function getProgramRequestStatusColor(statusId: ProgramRequestStatus) {
  switch (statusId) {
    case ProgramRequestStatus.CancelledASOO:
    case ProgramRequestStatus.CancelledMZO:
    case ProgramRequestStatus.RejectedASOO:
    case ProgramRequestStatus.Rejected:
      return "danger";
    case ProgramRequestStatus.Opened:
    case ProgramRequestStatus.UnlockedASOO:
    case ProgramRequestStatus.UnlockedMZO:
    case ProgramRequestStatus.HarmonizationUnlockedASOO:
      return "noted-2";
    case ProgramRequestStatus.SubmittedASOO:
    case ProgramRequestStatus.SubmittedMZO:
    case ProgramRequestStatus.Paused:
    case ProgramRequestStatus.PausedMZOM:
      return "warning";
    case ProgramRequestStatus.HarmonizationASOO:
    // case ProgramRequestStatus.HarmonizationMZO:
      return "primary";
    case ProgramRequestStatus.ConsentMZO:
    case ProgramRequestStatus.ConsentASOO:
    case ProgramRequestStatus.SentMZO:
      return "primary";
    case ProgramRequestStatus.Approved:
    case ProgramRequestStatus.Evaluated:
      return "success";
    default:
      return "success";
  }
}

export const isMinisterProgramRequest = (programTypeId: number | null | undefined) =>
  programTypeId === ProgramType.ProgramWithMinisterResolution;